module.exports = function() {
  return new Worker(__webpack_public_path__ + "ceef28efd35032a1aae7.worker.js");
};